import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Container, Icon } from 'components/HeroSemantic';
import { FormattedMessage, useIntl } from 'react-intl';
import ThemeButton from '../Theme/ThemeButton';

const ContactUsWidget = () => {
  const { locale } = useIntl();
  const navigate = useNavigate();
  const { id: tenantId, theme: { colors } } = useSelector(state => state.tenant);

  const onClick = () => {
    navigate(`/${locale}/general/contactUs`);
  };

  let backgroundColor = 'var(--owner-surface)';
  if (tenantId === 'nisekocentral') {
    backgroundColor = 'color-mix(in srgb, var(--tenant-primary) 5%, var(--owner-surface))';
  }
  const accentColor = tenantId === 'nisekocentral' ? 'var(--owner-accent-border)' : colors.secondary;

  return (
    <Container className="my-8" style={{ maxWidth: 760 }}>
      <div
        className="relative overflow-hidden rounded-xl border bg-[var(--owner-surface)] p-5 shadow-sm transition-shadow hover:shadow-md"
        style={{
          background: backgroundColor,
          borderColor: accentColor,
          boxShadow: 'var(--owner-shadow)',
        }}
      >
        <div
          aria-hidden
          className="absolute inset-y-0 left-0 w-1.5"
          style={{ background: 'var(--owner-accent-readable)' }}
        />
        <div className="flex flex-col gap-4 pl-2 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex min-w-0 items-center gap-4">
            <span
              className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-lg"
              style={{
                background: 'var(--owner-accent-subtle)',
                color: 'var(--owner-accent-readable)',
              }}
            >
              <Icon name="comment" />
            </span>
            <div className="min-w-0">
              <h4
                className="m-0 text-[15px] font-bold uppercase leading-5 tracking-normal"
                style={{ color: 'var(--owner-accent-readable)' }}
              >
                <FormattedMessage id="page.general.contactUs.title" />
              </h4>
              <p className="mt-1 mb-0 text-sm leading-5 text-[var(--owner-text-muted)]">
                <FormattedMessage id="page.general.contactUs.subtitle" />
              </p>
            </div>
          </div>
          <div className="w-full shrink-0 sm:w-auto">
            <ThemeButton
              fluid
              iconName="comment"
              onClick={onClick}
              size="small"
              style={{
                borderRadius: 8,
                boxShadow: '0 8px 20px rgba(15, 23, 42, 0.14)',
                minWidth: 132,
                padding: '0.75rem 1rem',
              }}
              titleId="page.general.contactUs.button"
            />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ContactUsWidget;
